import colors from 'style-utils/colors';
import { Flex } from 'style/flexbox.style';
import styled from 'styled-components';

export const ModalBodyContainer = styled(Flex)`
  padding: 24px 16px;
`;

export const BodyTextContainer = styled.p`
  margin: 0;
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  > span {
    display: block;
    &:not(:last-child) {
      margin-bottom: 22px;
    }
    > a {
      color: ${colors.blackTwelve};
    }
  }
  ul {
    list-style: disc;
    li {
      list-style: disc;
      margin-left: 25px;
    }
  }
`;

export const TelephoneLink = styled.a`
  font-weight: bold;
  color: ${colors.blackTwelve};
`;

export const ChatLink = styled.span`
  cursor: pointer;
  font-weight: bold;
  text-decoration: underline;
`;

export const ExternalLink = styled.a`
  display: inline;
  font-weight: bold;
  text-decoration: underline;
  color: ${colors.blackTwelve};
  overflow-wrap: normal;
`;
